import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=af6ae486&scoped=true"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=af6ae486&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6ae486",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af6ae486')) {
      api.createRecord('af6ae486', component.options)
    } else {
      api.reload('af6ae486', component.options)
    }
    module.hot.accept("./Confirm.vue?vue&type=template&id=af6ae486&scoped=true", function () {
      api.rerender('af6ae486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/confirm/Confirm.vue"
export default component.exports